/**
 * Tailwind CSS implementation of Breadcrumb component
 * Uses Seeds breadcrumb CSS classes from breadcrumb.css
 */

import * as React from "react";
import { BreadcrumbList } from "./BreadcrumbList";
import type { TypeBreadcrumbProps } from "./BreadcrumbTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const BreadcrumbTailwind = ({
  ariaLabel,
  overflow,
  children,
  className,
  ...rest
}: TypeBreadcrumbProps) => {
  return (
    <nav
      className={cn("seeds-breadcrumb", className)}
      aria-label={ariaLabel}
      data-qa-breadcrumb={ariaLabel}
      {...(rest as React.ComponentPropsWithoutRef<"nav">)}
    >
      <BreadcrumbList overflow={overflow}>{children}</BreadcrumbList>
    </nav>
  );
};

BreadcrumbTailwind.displayName = "BreadcrumbTailwind";
